import type { ReactNode } from 'react'
import { InfoTip, Text } from '~/shared/ui'

interface ProgressItemProps {
  totalValue: number | undefined
  value: number
  label: string
  summaryLabel: string
  summaryTotalValue?: number
  formatValue?: (value: number) => string
  infoTipContent?: ReactNode
}

export function ProgressItem({
  totalValue,
  value,
  label,
  summaryLabel,
  summaryTotalValue,
  formatValue = String,
  infoTipContent,
}: ProgressItemProps) {
  if (totalValue === undefined) {
    return (
      <div className="flex flex-col items-end gap-1">
        <div className="flex h-[18px] items-center gap-2">
          <Text
            className="text-text-secondary"
            appearance="CAPTION"
          >
            Waiting for data
          </Text>
          <InfoTip
            iconSize="16"
            align="end"
          >
            <Text
              className="text-text-secondary max-w-[140px] pr-6"
              appearance="CAPTION"
            >
              Complete the Payment Summary review to enable the tracker
            </Text>
          </InfoTip>
        </div>
        <div className="bg-content-low-emphasis h-1 w-40 rounded-full" />
      </div>
    )
  }

  const remaining = totalValue - value
  const progress = totalValue > 0 ? value / totalValue : 0

  return (
    <div className="flex flex-col items-end gap-1">
      <div className="flex items-center gap-1">
        <Text appearance="SUBTITLE2">{formatValue(remaining)}</Text>
        <Text appearance="CAPTION">{label}</Text>
        {infoTipContent && (
          <InfoTip
            iconSize="16"
            align="end"
          >
            {infoTipContent}
          </InfoTip>
        )}
      </div>
      <div className="bg-content-low-emphasis h-1 w-40 rounded-full">
        {progress > 0 && (
          <div
            className="bg-primary-main h-full rounded-full"
            style={{ width: `${Math.min(progress, 1) * 100}%` }}
          />
        )}
      </div>
      <Text
        className="text-text-secondary"
        appearance="CAPTION"
      >
        {summaryLabel}: {formatValue(summaryTotalValue ?? totalValue)}
      </Text>
    </div>
  )
}
